import { MouseEvent, useCallback, useEffect, useRef, useState } from 'react';
import BestSellerIcon from '@app/ahava/assets/saywhatt-bestseller.svg';
import IngredientsIcon from '@app/ahava/assets/saywhatt-ingridients.svg';
import RegimenIcon from '@app/ahava/assets/saywhatt-regimen.svg';
import RoutineIcon from '@app/ahava/assets/saywhatt-routine.svg';
import SettingsIcon from '@app/ahava/assets/saywhatt-settings.svg';
import { SendButton, Spinner } from '@/modules/common';
import { Form, H1Title, H2Title, LogoImage, PromptButton, Prompts, SpinnerWrapper, TextArea, WelcomeScreenWrapper } from './WelcomeScreen.styles';

const PROMPTS = ['Always 30% Off', 'Ingredients', 'Routine', 'How to use', 'Luminous Rewards'];
const PROMPTS_ICONS = [RegimenIcon, IngredientsIcon, RoutineIcon, SettingsIcon, BestSellerIcon];

export const WelcomeScreen = ({ isDisabled, visible, sendMessage }:{ isDisabled: boolean, visible: boolean, sendMessage: (input: string) => void }) => {
  const [value, setValue] = useState('');

  const formRef = useRef<HTMLFormElement>(null);

  const onSubmit = useCallback((e: React.FormEvent) => {
    e.preventDefault();
    sendMessage(value)
  }, [sendMessage, value]);

  const onClick = useCallback((e: MouseEvent<HTMLButtonElement>) => sendMessage(e.currentTarget.innerText), [sendMessage]);

  const handleKeyDown = useCallback((event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (isDisabled) {
      return;
    }

    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      sendMessage(value)
    }
  }, [sendMessage, value, isDisabled]);

  useEffect(() => {
    setValue('');
  }, [visible]);

  return (
    <WelcomeScreenWrapper visible={visible}>
      {isDisabled && (
        <SpinnerWrapper>
          <Spinner size={14} color="#B7925B" />
        </SpinnerWrapper>
      )}

      <H1Title>
        Welcome to <LogoImage />
      </H1Title>
      <H2Title>
        Hi! I'm Samantha, your personal AHAVA beauty guide. <br />
        I know all about our ingredients, and I'm here to match the right products
        to your skin type, age, and concerns. <br />
        I can also help you layer your products and build your custom routine. <br />
        Just tell me what's on your mind!
      </H2Title>

      <Form onSubmit={onSubmit} ref={formRef}>
        <TextArea
          onKeyDown={handleKeyDown}
          placeholder="Ask me anything about skincare"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        <SendButton type="submit" title="Send" disabled={isDisabled} isEmbedded />
      </Form>

      <Prompts>
        {PROMPTS.map((prompt, index) => (
          <PromptButton index={index + 1} key={index} ready={!isDisabled} disabled={isDisabled} onClick={onClick}>
            <img src={PROMPTS_ICONS[index]} />
            <span>{prompt}</span>
          </PromptButton>
        ))}
      </Prompts>
    </WelcomeScreenWrapper>
  );
}